<template>
    <div class="offboarding-start-screen">
        <div class="wrap">
            <base-user-avatar />
            <template
                v-if="1 >= activeUserSubscriptions"
            >
                <h2>{{ user.name }}, interested in switching to a free plan?</h2>
            </template>
            <template v-else>
                <h2>{{ user.name }}, do you want to cancel your plan?</h2>
            </template>
            <div class="offboarding-buttons">
                <template
                    v-if="1 >= activeUserSubscriptions"
                >
                    <base-submit-button
                        class="btn btn-primary"
                        :loading="formProcessing"
                        @click="convertToFree"
                    >
                        Yes, Convert to Free
                    </base-submit-button>
                    <button
                        class="btn btn-primary is-red"
                        @click="openCancelModal"
                    >
                        No, Cancel My Subscription
                    </button>
                </template>
                <template v-else>
                    <base-submit-button
                        class="btn btn-primary is-red multi-user-cancel-btn"
                        :loading="formProcessing"
                        @click="suspendUser"
                    >
                        No, Cancel My Subscription
                    </base-submit-button>
                    <router-link
                        class="cancel-link multi-user-cancel"
                        to="/settings/billing"
                    >
                        Go Back to the Dashboard
                    </router-link>
                </template>
            </div>
            <div class="downgrade-info">
                Your plan will be active until end of {{ subscriptionEndDate }}.
            </div>
        </div>
        <cancel-modal v-if="UIState.isCancelModalVisible" />
    </div>
</template>

<script>
import apiCall from '@/utils/apiCall';
import suspendUser from '@/utils/user/suspendUser';
import moment from 'moment';
import CancelModal from './CancelModal.vue';
import toasts from '@/mixins/toasts';
import { mapState, mapActions, mapMutations } from 'vuex';
import { filter } from 'lodash';

export default {
    components: {
        CancelModal,
    },

    mixins: [toasts],

    data: () => ({
        formProcessing: false,
    }),

    computed: {
        ...mapState([
            'user',
            'userSubscription',
            'UIState',
        ]),

        ...mapState({
            subscriptionEndDate: state =>
                state.userSubscription ? moment.unix(state.userSubscription.current_period_end).format('MMM D, YYYY') : '',
            activeUserSubscriptions: state =>
                filter(state.user.subscriptions, subscription => {
                    return 'pro' === subscription.name && 'canceled' !== subscription.stripe_status && null === subscription.ends_at;
                }).length,
        }),
    },

    methods: {
        ...mapMutations(['changeUIState']),
        ...mapActions([
            'updateUser',
            'loadUserSubscription',
        ]),

        /**
         * Converts user subscription to free
         */
        async convertToFree() {
            const { status } = await apiCall(this, 'delete', `/api/billing/subscriptions/${this.userSubscription.dbId}`);

            if (200 === status) {
                this.formProcessing = true;

                this.updateUser()
                    .then(async () => {
                        await this.loadUserSubscription({ force: true });

                        this.formProcessing = false;

                        this.changeUIState({ isFinishDowngradeView: true });
                    })
                    .catch(() => {
                        this.formProcessing = false;

                        this.toastError({
                            message: {
                                title: 'We couldn\'t convert Your subscription. Please contact us, or try again later',
                            },
                        });
                    });
            } else {
                this.formProcessing = false;

                this.toastError({
                    message: {
                        title: 'We couldn\'t convert Your subscription. Please contact us, or try again later',
                    },
                });
            }
        },

        /**
         * Opens cancel modal
         */
        openCancelModal() {
            this.changeUIState({ isCancelModalVisible: true });
        },

        /**
         * Suspends user account
         */
        suspendUser() {
            suspendUser(this);
        },
    },

};
</script>
